export default __webpack_public_path__ + "images/ecb981cb1da5b14657d5c3e2964ecaf0.svg";